module.exports = '<svg width="36" height="32" viewBox="0 0 36 32"><path d="M35.766 29.41l-16-28.48c-.696-1.24-2.836-1.24-3.532 0l-16 28.48c-.33.59-.31 1.196.052 1.77.36.57 1.01.82 1.714.82h32c.704 0 1.354-.25 1.714-.82.362-.574.382-1.18.052-1.77zM20 27.12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zM20 21a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/exclamation-point-1.js
// module id = 1125
// module chunks = 14